import FormattedPrice from './FormattedPrice';

export default FormattedPrice;



// WEBPACK FOOTER //
// ./src/components/shared/FormattedPrice/index.jsx